// src/components/ErrorMessage.jsx
import React from 'react';
import Alert from 'react-bootstrap/Alert';

const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return (
    <Alert variant='danger' className='mt-3'>
      <Alert.Heading as='h6'>Lỗi</Alert.Heading>
      <p className='mb-0'>{message}</p>
    </Alert>
  );
};

export default ErrorMessage;
